import { CustomModalLayout, Loader } from '@wix/design-system';
import React from 'react';
import { useDowngradeModal } from '../../hooks/useDowngradeModal';
import { SwitchProductModule } from '../../switch-product.module';
import { getSubscriptionsUrl } from '../../utils';
import { DowngradeModalContext } from '../DowngradeModalContext';
import { CompareProducts } from './CompareProducts/CompareProducts';
import { DisabledFeaturesMessage } from './DisabledFeaturesMessage/DisabledFeaturesMessage';
import { Summary } from './Summary/Summary';
const OPERATION_MAP = {
  Extend: 'switchAndExtend',
  Refund: 'switchAndRefund',
  GracePeriod: 'switchInGracePeriod'
};
export const DowngradeModal = _ref => {
  let {
    targetProductId,
    callbacks
  } = _ref;
  return /*#__PURE__*/React.createElement(DowngradeModalContext.Provider, {
    value: {
      targetProductId
    }
  }, /*#__PURE__*/React.createElement(DowngradeModalContent, {
    callbacks: callbacks
  }));
};
const DowngradeModalContent = _ref2 => {
  let {
    callbacks,
    isOpen
  } = _ref2;
  const {
    t
  } = SwitchProductModule.internals.useTranslations();
  const {
    downgradeAction,
    downgradeDetails,
    isLoading
  } = useDowngradeModal();
  const {
    modalsController
  } = SwitchProductModule.internals;
  const callbackProps = React.useMemo(() => ({
    productId: downgradeDetails == null ? void 0 : downgradeDetails.destinationProductDetails.productGuid,
    newProductId: downgradeDetails == null ? void 0 : downgradeDetails.destinationProductDetails.productGuid,
    downgradeType: downgradeDetails == null ? void 0 : downgradeDetails.downgradeType,
    cycle: downgradeDetails == null ? void 0 : downgradeDetails.currentPlanDetails.paymentCycle,
    newCycle: downgradeDetails == null ? void 0 : downgradeDetails.destinationProductDetails.paymentCycle
  }), [downgradeDetails == null ? void 0 : downgradeDetails.destinationProductDetails.productGuid, downgradeDetails == null ? void 0 : downgradeDetails.downgradeType, downgradeDetails == null ? void 0 : downgradeDetails.currentPlanDetails.paymentCycle, downgradeDetails == null ? void 0 : downgradeDetails.destinationProductDetails.paymentCycle]);
  const handleErrorModalShow = React.useCallback(error => {
    modalsController.DowngradeModal.hide();
    modalsController.DowngradeErrorModal.show({
      errorType: 'changeProductFailed',
      error,
      callbacks: callbacks == null ? void 0 : callbacks.errorCallbacks
    });
  }, [callbacks == null ? void 0 : callbacks.errorCallbacks, modalsController]);
  React.useEffect(() => {
    if (!(downgradeDetails != null && downgradeDetails.downgradeType) && isOpen) {
      handleErrorModalShow(new Error('No downgrade type'));
      return;
    }
    callbacks == null || callbacks.onShow == null || callbacks.onShow(callbackProps);
  }, [callbackProps, callbacks, downgradeDetails, handleErrorModalShow, isOpen]);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  const handlePrimaryButtonClick = async () => {
    callbacks == null || callbacks.onPrimaryButtonClick == null || callbacks.onPrimaryButtonClick(callbackProps);
    try {
      const downgradeType = downgradeDetails == null ? void 0 : downgradeDetails.downgradeType;
      const result = downgradeType ? await downgradeAction({
        operation: OPERATION_MAP[downgradeType]
      }) : undefined;
      modalsController.DowngradeModal.hide();
      if ((result == null ? void 0 : result.status) !== 'success') {
        handleErrorModalShow(result == null ? void 0 : result.error);
        return;
      }
      if (downgradeType === 'GracePeriod') {
        const url = getSubscriptionsUrl({
          params: {
            referralInfo: 'AdvancedPlans_changePlan'
          }
        });
        window.location.assign(url);
        return;
      }
      modalsController.DowngradeSuccessModal.show({
        callbacks: callbacks == null ? void 0 : callbacks.successCallbacks
      });
    } catch (error) {
      handleErrorModalShow(error);
    }
  };
  const handleCloseModal = () => {
    callbacks == null || callbacks.onClose == null || callbacks.onClose(callbackProps);
    modalsController.DowngradeModal.hide();
  };
  return /*#__PURE__*/React.createElement(CustomModalLayout, {
    maxWidth: "840px",
    title: t('change_plan.change_plan_modal.title'),
    primaryButtonText: t((downgradeDetails == null ? void 0 : downgradeDetails.downgradeType) === 'GracePeriod' ? 'change_plan.change_plan_modal.continue' : 'change_plan.change_plan_modal.confirm_change'),
    primaryButtonOnClick: handlePrimaryButtonClick,
    secondaryButtonText: t('change_plan.change_plan_modal.cancel'),
    secondaryButtonOnClick: handleCloseModal,
    onCloseButtonClick: handleCloseModal
  }, /*#__PURE__*/React.createElement(CompareProducts, null), /*#__PURE__*/React.createElement(Summary, {
    onLinkClick: urlKey => callbacks == null || callbacks.onLinkClick == null ? void 0 : callbacks.onLinkClick({
      ...callbackProps,
      urlKey
    })
  }), /*#__PURE__*/React.createElement(DisabledFeaturesMessage, null));
};
//# sourceMappingURL=DowngradeModal.js.map